import React, { useState, useEffect } from 'react'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import { useSelector } from 'react-redux'
import { dispatch } from '../../../../redux/store'
import { Box, ListItem, ListItemText, ListSubheader, Skeleton } from '@mui/material'
import PublicIcon from '@mui/icons-material/Public'
import { InputAdornment } from '@mui/material'
import Image from 'next/image';

const HotelDestination = ({
  setCityValue,
  cityValue,
  setSearchProduct,
  searchProduct,
  selectedValue,
  setSelectedValue,
  label,
  placeholder,
  setLoading,
  loading,
  autocompleteFirst,
  queryValue = '',
  error,
  helperText
}) => {
  const { cityListRes } = useSelector(state => state.activity)
  const [cityList, setCityList] = useState([])
  const handleAutocompleteChange = (event, value) => {
    // Use the retrieved value as needed

    // const filterCode = city.filter((data) => value === data.cityName);
    setCityValue(value)
    // setValue(filterCode[0]?.countryName);
    //
  }

  // const flattenedOptions=[];
  const flattenedOptions = cityValue?.reduce((acc, curr) => {
    return [
      ...acc,
      ...curr.values.map(value => ({
        group: curr.label,
        img: curr.img,
        ...value
      }))
    ]
  }, [])

  const [isOnChange, setIsOnChange] = useState(true)

  useEffect(() => {
    if (queryValue) {
      setIsOnChange(false)
    } else {
      if (isOnChange && flattenedOptions.length > 0) {
        setSelectedValue(flattenedOptions[0])
        setIsOnChange(false)
      }
    }
  }, [flattenedOptions, isOnChange])

  return (
    <>
      <Box className={`searchMenu-loc lg:px-0 js-form-dd`}
        sx={{
          '& label.Mui-focused': {
            color: 'black'
          },
          '& .MuiInputBase-input': {
            // height: "16px",
          },
          '& .MuiAutocomplete-clearIndicator': {
            display: 'none' // Hides the clear (close) button
          },

          '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: '1px solid rgba(0, 0, 0, 0.5)'
          },
          '& .MuiInput-underline:after': {
            border: '1px solid rgba(0, 0, 0, 0.5)'
          },
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              border: '1px solid rgba(0, 0, 0, 0.5)',
              borderRadius: '8px'
            },
            '&:hover fieldset': {
              border: '1px solid rgba(0, 0, 0, 0.5)'
            },
            '&.Mui-focused fieldset': {
              border: '1px solid rgba(0, 0, 0, 0.5)'
            }
          }
        }}>

        <Autocomplete
          size='small'
          value={selectedValue}
          ref={autocompleteFirst}
          onChange={(event, newValue) => {
            setSelectedValue(newValue) // Update the selected value in state
          }}
          filterOptions={x => x}
          onInputChange={(event, newInputValue) =>
            setSearchProduct(newInputValue)
          }
          // loading={loading}
          // noOptionsText={`No results found for ${searchProduct}`}
          noOptionsText={
            loading ? (
              <Skeleton variant='text' sx={{ fontSize: '1rem' }} />
            ) : (
              <div
                style={{
                  padding: '16px',
                  textAlign: 'center',
                  color: '#666',
                  fontSize: '14px',
                  backgroundColor: '#f8f9fa',
                  borderRadius: '8px'
                }}
              >
                <strong style={{ fontSize: '16px', color: '#333' }}>
                  No results found for {searchProduct}
                </strong>
                <p style={{ marginTop: '5px' }}>
                  Try searching with a different keyword.
                </p>
              </div>
            )
          }
          options={flattenedOptions}
          groupBy={option => option.group}
          getOptionLabel={option => option.name} // Display name as the label in the input
          renderInput={params => (
            <TextField
              {...params}
              label={label}
              placeholder={placeholder}
              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <InputAdornment position='start'>
                    <PublicIcon />
                  </InputAdornment>
                ),
                style: error ? { borderColor: 'red' } : {}
              }}
              error={error}
              helperText={helperText}
            />
          )}
          renderOption={(props, option) => (
            <ListItem {...props}>
              <div
                style={{
                  minWidth: '35px',
                  textAlign: 'left'
                }}
              >
                <Image
                  height='100'
                  width='100'
                  style={{
                    width: '20px',
                    height: '20px'
                  }}
                  alt={option.name}
                  src={option.img}
                />
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'flex-start'
                }}
              >
                <ListItemText
                  primaryTypographyProps={{
                    sx: { fontSize: '14px' }
                  }}
                  primary={option.name}
                  style={{ marginTop: 0, marginBottom: 0 }}
                />
                <ListItemText
                  primaryTypographyProps={{
                    sx: { fontSize: '12px' }
                  }}
                  primary={option.countryName}
                  style={{ marginTop: 0, marginBottom: 0 }}
                />
              </div>
            </ListItem>
          )}
        />
      </Box>
    </>
  )
}

export default HotelDestination
